module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ../~/vue2-google-maps/~/core-js/library/modules/$.a-function.js
// module id = 122
// module chunks = 0